/* Teams & sharing (COLLAB-01, 03, 04, 05; ENT-01, 02, 03). API: api/src/modules/collab/README.md.
   Other features embed the share dialog with `import { ShareDialog } from '../collab/ShareDialog'`. */
import { lazy } from 'react';
import { Users } from 'lucide-react';
import { defineFeature } from '../../app/feature';

export default defineFeature({
  id: 'collab',
  title: 'Teams & sharing',
  short: 'Teams',
  icon: Users,
  group: 'Account',
  route: '/teams',
  order: 20,
  screen: lazy(() => import('./Screen.tsx')),
  commands: [
    { id: 'invite', title: 'Invite people to your organization', to: '/teams?invite=1', keywords: ['team', 'member', 'seat'] },
    { id: 'new-group', title: 'New group chat', to: '/teams/groups?new=1', keywords: ['group', 'chat', 'team'] },
    { id: 'policies', title: 'Organization policies', to: '/teams?section=policies', keywords: ['admin', 'connectors', 'models', 'byok'] },
    { id: 'audit', title: 'Audit log', to: '/teams?section=audit', keywords: ['admin', 'security', 'export'] },
    { id: 'sharing', title: 'My share links', to: '/teams/sharing', keywords: ['share', 'link', 'public'] },
  ],
  capabilities: ['COLLAB-01', 'COLLAB-03', 'COLLAB-04', 'COLLAB-05', 'ENT-01', 'ENT-02', 'ENT-03'],
});
